import {
  GET_SUGGESTED_QUESTIONS_REQUEST,
  GET_SUGGESTED_QUESTIONS_SUCCESS,
  GET_SUGGESTED_QUESTIONS_FAILURE,
  CREATE_SUGGESTED_QUESTION_REQUEST,
  CREATE_SUGGESTED_QUESTION_SUCCESS,
  CREATE_SUGGESTED_QUESTION_FAILURE,
  UPDATE_SUGGESTED_QUESTION_REQUEST,
  UPDATE_SUGGESTED_QUESTION_SUCCESS,
  UPDATE_SUGGESTED_QUESTION_FAILURE,
  DELETE_SUGGESTED_QUESTION_REQUEST,
  DELETE_SUGGESTED_QUESTION_SUCCESS,
  DELETE_SUGGESTED_QUESTION_FAILURE,
  GET_WIDGET_COLOR_REQUEST,
  GET_WIDGET_COLOR_SUCCESS,
  GET_WIDGET_COLOR_FAILURE,
  SAVE_WIDGET_COLOR_REQUEST,
  SAVE_WIDGET_COLOR_SUCCESS,
  SAVE_WIDGET_COLOR_FAILURE,
  SAVE_TERMS_CONDITIONS_REQUEST,
  SAVE_TERMS_CONDITIONS_SUCCESS,
  SAVE_TERMS_CONDITIONS_FAILURE,
} from '../actions/widgetActions';

const initialState = {
  suggestedQuestions: [],
  loading: false,
  creating: false,
  error: null,
  widgetColor: '#000000', // Default widget color
  widgetColorLoading: false,
  savingTerms: false,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 25
  }
};

const widgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUGGESTED_QUESTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_SUGGESTED_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        suggestedQuestions: action.payload.data || action.payload.questions || [],
        pagination: {
          currentPage: action.payload.pagination?.currentPage || 1,
          totalPages: action.payload.pagination?.totalPages || 1,
          totalItems: action.payload.pagination?.totalCount || action.payload.pagination?.totalItems || 0,
          limit: action.payload.pagination?.limit || 25
        },
        error: null,
      };

    case GET_SUGGESTED_QUESTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case CREATE_SUGGESTED_QUESTION_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case CREATE_SUGGESTED_QUESTION_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
      };

    case CREATE_SUGGESTED_QUESTION_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.error,
      };

    case UPDATE_SUGGESTED_QUESTION_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case UPDATE_SUGGESTED_QUESTION_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
      };

    case UPDATE_SUGGESTED_QUESTION_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.error,
      };

    case DELETE_SUGGESTED_QUESTION_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };

    case DELETE_SUGGESTED_QUESTION_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null,
      };

    case DELETE_SUGGESTED_QUESTION_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.error,
      };

    case GET_WIDGET_COLOR_REQUEST:
      return {
        ...state,
        widgetColorLoading: true,
        error: null,
      };

    case GET_WIDGET_COLOR_SUCCESS:
      return {
        ...state,
        widgetColorLoading: false,
        widgetColor: action.payload.data?.color || action.payload.color || '#000000',
        error: null,
      };

    case GET_WIDGET_COLOR_FAILURE:
      return {
        ...state,
        widgetColorLoading: false,
        error: action.error,
      };

    case SAVE_WIDGET_COLOR_REQUEST:
      return {
        ...state,
        widgetColorLoading: true,
        error: null,
      };

    case SAVE_WIDGET_COLOR_SUCCESS:
      return {
        ...state,
        widgetColorLoading: false,
        widgetColor: action.payload.color,
        error: null,
      };

    case SAVE_WIDGET_COLOR_FAILURE:
      return {
        ...state,
        widgetColorLoading: false,
        error: action.error,
      };

    case SAVE_TERMS_CONDITIONS_REQUEST:
      return {
        ...state,
        savingTerms: true,
        error: null,
      };

    case SAVE_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        savingTerms: false,
        error: null,
      };

    case SAVE_TERMS_CONDITIONS_FAILURE:
      return {
        ...state,
        savingTerms: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default widgetReducer;
